import { withStyles } from '@material-ui/core/styles';
import { TableSortLabel, Theme } from '@material-ui/core';

export const PasslyTableSortLabel = withStyles((theme: Theme) => ({
    root: {
        '&$active': {
            color: theme.palette.primary.main,
            '&& $icon': {
                opacity: 1,
                color: theme.palette.text.secondary,
            },
        },
    },
    active: {
        color: theme.palette.secondary.main
    }
}))(TableSortLabel);
